const getIllustrationUrl = ({ src, cdnUrl, illustrationId, }) => {
    if (src) {
        return src;
    }
    if (!illustrationId || !cdnUrl) {
        return "#";
    }
    return `${cdnUrl}${illustrationId}.svg`;
};
export { getIllustrationUrl };
//# sourceMappingURL=Illustration.helpers.js.map